import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {useApplication} from "../../ApplicationProvider";
import {Avatar, Box, Link, Typography, useTheme} from "@mui/material";
import saporeLogo from "../../media/sapore-di-pane-logo.jpeg";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import LoginFeature from "./LoginFeature";
import {useNavigatorFeature} from "../../useFeature";
import {styles} from "./LoginStyles";
import FilledButton from "../../components/buttons/FilledButton";
import FormTextField from "../../components/fields/FormTextField";
import FormColumn from "../../forms/FormColumn";
import {PASSWORD_RESET_PATH} from "../../routes";
import FormPasswordField from "../../components/fields/FormPasswordField";
import ThemeToggleButton from "../../components/buttons/ThemeToggleButton";

function LoginScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const theme = useTheme();
    const style = styles(theme);
    const feature = useNavigatorFeature(() => new LoginFeature(application, navigator), navigator);
    const business = application.business()

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        // TODO: Discuss with Mati & Flor how to get rid of this
        feature.login()
    }

    // TODO fill password recover and register url when implemented
    const loginContent = () => {
        return (
            <Box style={style.loginContainer}>
                <Box style={style.themeToggleContainer}>
                    <ThemeToggleButton variant="login" />
                </Box>
                <Box style={style.loginBox}>
                    <Box style={style.loginHeader}>
                        <Avatar src={saporeLogo} alt="Sapore di Pane" sx={style.avatarIcon}/>
                        <Typography sx={style.brandTitle}>Sapore di Pane</Typography>
                    </Box>
                    <Box onSubmit={(event) => handleSubmit(event)} component="form" noValidate sx={style.formContainer}>
                        <FormColumn>
                            <FormTextField label="Dirección de email" field={feature.form.getFieldByName("email")}/>
                            <Box>
                                <FormPasswordField label="Contraseña" field={feature.form.getFieldByName("password")}/>
                                <Link href={PASSWORD_RESET_PATH} variant="body2" style={style.passwordResetLink}>
                                    ¿Olvidaste tu contraseña?
                                </Link>
                            </Box>
                        </FormColumn>
                        <Box sx={style.loginButtonContainer}>
                            <FilledButton type="submit" style={style.loginButton}>
                                Iniciar sesión
                            </FilledButton>
                        </Box>
                        {/*<Box sx={style.createAccountLinkContainer} component="p">*/}
                        {/*    ¿No tienes una cuenta?*/}
                        {/*    <Link href="" variant="body2" style={style.createAccountLink}>*/}
                        {/*        Regístrate*/}
                        {/*    </Link>*/}
                        {/*</Box>*/}
                    </Box>
                </Box>
            </Box>
        )
    }

    return <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => loginContent()} skeleton={<></>}/>
}

export default observer(LoginScreen)
